import { c as _c } from "react/compiler-runtime";
import type React from 'react';
import { ToastProvider } from '../../components/toast';
import ConfirmationDialogProvider from '../confirmation-dialog-provider';
export type BootstrapProps = {
  children: React.ReactNode;
};
const DesignSystemProvider = t0 => {
  const $ = _c(6);
  const {
    children
  } = t0;
  let t1;
  if ($[0] !== children) {
    t1 = <ConfirmationDialogProvider><ToastProvider>{children}</ToastProvider></ConfirmationDialogProvider>;
    $[0] = children;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div id="footprint-portal" />;
    t3 = <div id="footprint-toast-portal" />;
    $[2] = t2;
    $[3] = t3;
  } else {
    t2 = $[2];
    t3 = $[3];
  }
  let t4;
  if ($[4] !== t1) {
    t4 = <>{t1}{t2}{t3}</>;
    $[4] = t1;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  return t4;
};
export default DesignSystemProvider;